/**
 * @description Gestion des alertes
 */

(() => {
  // VARS
  const alert = {
    root: document.querySelector('.layout-container'), // Endroid d'insertion de la popin
    url: drupalSettings.yellowstone.alert.urlLookForAlert, // url
    save: drupalSettings.yellowstone.alert.urlRegisterView, // url register
    content: 'data-popin-content', // content register
    close: 'data-popin-close', // attribue de fermeture
  };

  // FONCTIONS

  /**
   * @description Création de la popin
   * @param {JSON} data
   */
  const content = data => {
    let popin = '';

    popin += `
        <div class="popin${data.is_alert === 1 ? ' alert' : ''}${
      typeof data.url !== 'undefined' && data.url && data.is_alert === 1
        ? ' alert__link'
        : ''
    }" data-id="${data.id}" ${alert.content}>`;

    if (
      typeof data.thumbnail !== 'undefined' &&
      data.thumbnail &&
      data.is_alert === 0
    ) {
      popin += `<div class="popin__img" style="background-image: url('${data.thumbnail}');"></div>`;
    }
    popin += `<div class="popin__content">
              <div class="popin__title">
                ${
                  data.is_alert === 1
                    ? ' <i class="list-group-item__icon btn-icon btn-icon-secondary btn-icon--squared" data-icon="warning"></i>'
                    : ''
                }
                <h2 class="popin__title" data-dot="2">${data.title}</h2>
              </div>
              <div class="popin__paragraph">
                ${data.text}
              </div>`;

    if (typeof data.url !== 'undefined' && data.url) {
      popin += `<div class="popin__link"><a class="popin__link__click" href="${
        data.url.link
      }"${data.url.isExternal ? ' target="_blank"' : ''} ${
        alert.close
      }-more>En savoir plus<i data-icon="arrow"></i></a></div>`;
    }

    popin += `</div>
            <button class="popin__close" ${alert.close}> <i data-icon="cross"></i></button>
          </div>
        `;

    return popin;
  };

  /**
   * @description Insertion de la popin dans le DOM
   * @param {JSON} data
   */
  const appendContent = data => {
    if (typeof data.title !== 'undefined' && data.title) {
      alert.root.insertAdjacentHTML('afterbegin', content(data));
    }
  };

  /**
   * @description suppression de l'alerte
   *
   */
  const alertContentView = () => {
    const id = document
      .querySelector(`[${alert.content}]`)
      .getAttribute('data-id');
    $get(`${alert.save}?id=${id}`);
    document
      .querySelector(`[${alert.content}]`)
      .classList.add('popin__close__content');
    setTimeout(() => {
      document.querySelector(`[${alert.content}]`).remove();
    }, 1500);
  };

  /**
   * @description Interaction avec la popin
   * @param {JSON} data
   */
  const event = data => {
    if (typeof data !== 'undefined' && data) {
      if (document.querySelector(`[${alert.close}]`)) {
        document
          .querySelector(`[${alert.close}]`)
          .addEventListener('click', () => {
            alertContentView();
          });
      }
      if (document.querySelector(`[${alert.close}-more]`)) {
        document
          .querySelector(`[${alert.close}-more]`)
          .addEventListener('click', () => {
            alertContentView();
          });
      }
    }
  };

  // GO 🚀
  const init = () => {
    if (alert.url) {
      $get(alert.url).then(data => {
        appendContent(data);
        event(data);
      });
    }
  };

  init();
})();
